import { Pipe, PipeTransform } from "@angular/core";
import { EnvioDTO } from "@DTOS";

@Pipe({
    name: "claseEnvioCss"
})
export class ClaseEnvioCssPipe implements PipeTransform {

    transform(envio: EnvioDTO): string {
        const dispatched = envio.fechaEnvio.getMilliseconds() < Date.now();
        return envio.activo ?
            (dispatched ? "fondo-circulo-activado" : "fondo-circulo-esperando") : "fondo-circulo-desactivado";
    }

}
